import styled from 'styled-components'

// import theme from 'configs/theme'

const Styled = styled.div`
  .ant-input-number {
    border-radius: 10px;
  }
`

export default Styled
